module.exports = __webpack_public_path__ + "static/media/acciocurios.beecabca.png";